<template>
  <div>

    <div class="well">
      <form autocomplete="off" class="form-horizontal" @submit.prevent="validateBeforeSubmit">
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="email">Email:</label>

          <div class="col-md-8" :class="{ 'has-error': errors.has('email') }">
            <input autocomplete="off" name="email" v-model="user.email" v-validate data-vv-rules="required|email"
              class="form-control" type="email" id="email" placeholder="Email"
              :class="{ 'has-error': errors.has('email') }">
            <span v-show="errors.has('email')" class="text-danger">
              {{ errors.first('email') }}
            </span>
          </div>
        </div>



        <div class="form-group row">
          <label class="col-form-label col-md-4" for="password">Password:</label>

          <div class="col-md-8" :class="{ 'has-error': errors.has('password') }">
            <div class="password-field">
              <input autocomplete="off" name="password" v-model="user.password" v-validate data-vv-rules="required|min:6"
                class="form-control" :type="showPassword ? 'text' : 'password'" id="password" placeholder="Password"
                :class="{ 'has-error': errors.has('password') }">
              <button
                type="button"
                class="password-toggle"
                :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                @click="showPassword = !showPassword"
              >
                <i class="fa" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
              </button>
            </div>
            <span v-show="errors.has('password')" class="text-danger">
              {{ errors.first('password') }}
            </span>
          </div>
        </div>

        <!-- <div class="form-group row text-center">
          <div class="col-md-12" :class="{ 'has-error' : errors.has('mantener_sesion') }">
            <label
            class="col-form-label"
            for="mantener_sesion">
            Mantener Sesión iniciada:
            <input
              name="mantener_sesion"
              v-model="user.mantener_sesion"
              class="checkbox"
              type="checkbox"
              id="mantener_sesion"
            >
            <span
              v-show="errors.has('mantener_sesion')"
              class="text-danger"
            >
              {{ errors.first('mantener_sesion') }}
            </span>
            
          </label>

            
          </div>
        </div> -->
        <hr />

        <button type="submit" class="btn btn-danger btn-block" v-html="btnText">
        </button>
      </form>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'user-form',
  props: {
    user: {
      type: Object,
      required: true
    },
    isLogin: {
      type: Boolean
    },
    isRegister: {
      type: Boolean
    },
    isProfile: {
      type: Boolean
    },
    btnText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      error: null,
      showPassword: false
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          //hay errores
        } else {
          this.$emit('processUserForm', this.user);
        }
      })
    }
  }
}
</script>

<style scoped>
/* Formulario moderno */
.well {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  box-shadow: none;
}

.form-horizontal {
  width: 100%;
}

/* Form Groups */
.form-group {
  margin-bottom: 1rem;
}

.form-group.row {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  margin-right: 0;
}

/* Labels */
.col-form-label {
  padding: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #1a1a2e;
  text-align: left;
}

/* Input containers */
.col-md-8,
.col-md-4 {
  padding: 0;
  width: 100%;
  max-width: 100%;
  flex: 0 0 100%;
}

/* Inputs modernos */
.password-field {
  position: relative;
  width: 100%;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  width: 2.2rem;
  height: 2.2rem;
  border: none;
  background: transparent;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.password-toggle:hover {
  background: rgba(13, 78, 140, 0.08);
  color: #0D4E8C;
}

.password-toggle:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(13, 78, 140, 0.2);
}

.form-control {
  width: 100%;
  padding: 0.875rem 3rem 0.875rem 1.125rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1a2e;
  background-color: #f5f7fa;
  background-clip: padding-box;
  border: 2px solid #e8ecf1;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.form-control::placeholder {
  color: #b0b0c8;
  opacity: 1;
}

.form-control:focus {
  color: #1a1a2e;
  background-color: #ffffff;
  border-color: #0D4E8C;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(13, 78, 140, 0.1);
}

.form-control:hover:not(:focus) {
  border-color: #d0d5dd;
  background-color: #ffffff;
}

/* Estados de error */
.has-error .form-control {
  border-color: #ff3b30;
  background-color: #fff5f5;
}

.has-error .form-control:focus {
  border-color: #ff3b30;
  box-shadow: 0 0 0 3px rgba(255, 59, 48, 0.1);
}

/* Mensajes de error */
.text-danger {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #ff3b30;
  font-weight: 500;
}

/* Separador */
hr {
  margin: 1.5rem 0;
  border: none;
  border-top: 1px solid #e8ecf1;
}

/* Botón moderno */
.btn {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: none;
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-danger {
  color: #ffffff;
  background: linear-gradient(135deg, #0D4E8C 0%, #005a9e 100%);
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.3);
}

.btn-danger::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(13, 78, 140, 0.4);
  background: linear-gradient(135deg, #005a9e 0%, #0D4E8C 100%);
}

.btn-danger:hover::before {
  width: 300px;
  height: 300px;
}

.btn-danger:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.3);
}

.btn-danger:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(13, 78, 140, 0.2), 0 4px 12px rgba(13, 78, 140, 0.3);
}

/* Animación de carga para el botón */
.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Checkbox estilo moderno (si se descomenta) */
.checkbox {
  width: 20px;
  height: 20px;
  margin-left: 0.5rem;
  cursor: pointer;
  border-radius: 6px;
}

/* Responsive */
@media (max-width: 768px) {
  .form-control {
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
  }

  .btn {
    padding: 0.75rem 1.25rem;
    font-size: 0.95rem;
  }

  .col-form-label {
    font-size: 0.875rem;
  }

  .text-danger {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {

  .form-control {
    padding: 0.625rem 0.875rem;
    font-size: 0.9rem;
    border-radius: 10px;
  }

  .btn {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
    border-radius: 10px;
  }

  .col-form-label {
    font-size: 0.85rem;
    margin-bottom: 0.375rem;
  }
}

.btn:focus-visible {
  outline: 2px solid #0D4E8C;
  outline-offset: 2px;
}

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-group {
  animation: fadeInUp 0.4s ease-out backwards;
}

.form-group:nth-child(1) {
  animation-delay: 0.1s;
}

.form-group:nth-child(2) {
  animation-delay: 0.2s;
}

.btn {
  animation: fadeInUp 0.4s ease-out 0.3s backwards;
}
</style>
